/** Default base path for Seeq REST API endpoints. */
export const APPSERVER_API_PREFIX = '/api';

/** Content-Type/Accept header value used by Seeq REST APIs. */
export const APPSERVER_API_CONTENT_TYPE = 'application/vnd.seeq.v1+json';

/** Header name used to track Seeq request IDs. */
// NOTE: This is a duplicate of the constant defined in
// client/packages/webserver/app/src/main/app.constants.seeqnames.ts and will need to be replaced when a common shared
// constants package is created.
export const SEEQ_REQUEST_ID_HEADER = 'x-sq-request-id';
